/*
 * Icon library here: https://fonts.google.com/icons
 * All icons with use the same className of "material-symbols-rounded" (rounded version)
 *
 * `permissionsFlag` is only added if the item itself is only visible based off of Redux permissions.
 * e.g. Ledger item will run a permission check in `App.js` to check the value `isLiveLedgerEnabled`
 * and only render if the value is `1` or `true`; see `navigationPermissions.js` for more info there.
 */
const NAVIGATION_ITEMS = [
    {
        label: 'My Applications',
        path: '/',
        icon: 'team_dashboard'
    },
    {
        label: 'Apply Now',
        path: '/apply',
        icon: 'edit_note'
    }
];

export default NAVIGATION_ITEMS;
